import { Directive, ElementRef, Input, OnInit, inject } from "@angular/core";
import tippy, { Content, Placement } from "tippy.js";

@Directive({
  selector: "[appTooltip]",
  standalone: false,
})
export class TooltipDirective implements OnInit {
  private element = inject(ElementRef);

  @Input() tooltipContent: Content = "";
  @Input() tooltipPlacement: Placement = "auto";
  @Input() tooltipInteractive = true;

  ngOnInit() {
    tippy(this.element.nativeElement, {
      allowHTML: true,
      theme: "light",
      interactive: this.tooltipInteractive,
      content: this.tooltipContent,
      placement: this.tooltipPlacement,
      appendTo: document.body,
    });
  }
}
